// 在系统后台页面 打开F12
// 在console里面 执行以下代码
// 得到下面配置的 functionList
/*
var arr = [];
$('.menu-box-wrap a').each(function () {
  var $a = $(this);
  var href = $a.attr('href') || '';
  var name = $.trim($a.text());
  if (href.indexOf('/trace/product/process/') >= 0) {
    var id = href.split('/trace/product/process/')[1];
    arr.push({ id, name })
  }
});
console.log(JSON.stringify(arr, null, 2));
*/

module.exports = [
  {
    id: "360a84b5115b42debd2ecc29b8931a18",
    name: "官网首页logo配置",
  },
  {
    id: "52d8d1ee30b241b8b6b46b25e2986e94",
    name: "官网子页logo配置",
  },
  {
    id: "4525df21db1347c49988efab30fcbe41",
    name: "公司官网轮播图",
  },
  {
    id: "937a43f8657d418ab805141389fc5c14",
    name: "官网数据配置",
  },
  {
    id: "ac8ea8a5de6246d69aed975fa18a34b5",
    name: "官网首页子模块1",
  },
  {
    id: "babdd7710a47402eba63b7069b5893d3",
    name: "官网首页子模块2",
  },
  {
    id: "7bb4aafe945d404f824d40d64392cc1d",
    name: "官网首页子模块3",
  },
  {
    id: "29504eab19064d3788b36ef77ffb209d",
    name: "官网首页子模块4",
  },
  {
    id: "ebd4a63481c548ae8348385381fa56c4",
    name: "官网首页子模块5",
  },
  {
    id: "53df4e632b69431897a65d8333ed2228",
    name: "官网首页子模块6",
  },
  {
    id: "1e5f4a875f0e49e9a9ce8e7a125d2280",
    name: "官网首页子模块7",
  },
  {
    id: "d93b39cbae7e4365a91236fae2fc6cdb",
    name: "官网友情链接配置",
  },
  {
    id: "755cd149de10475984efa2a75cd6d044",
    name: "公司官网导航",
  },
  {
    id: "0509d23231484d8d94b0024ff3b045fe",
    name: "官网新媒体矩阵",
  },
  {
    id: "97ed08282f294d9c8cc945d8ea27b759",
    name: "官网其它平台号",
  },
  {
    id: "083591da17be41fcb111d4a9fd13d91c",
    name: "最新动态配置",
  },
  {
    id: "d35259b624a249f28340de64c42cff6a",
    name: "官网企业客户配置",
  },
  {
    id: "05c9119a3613467e9b96dcd036151474",
    name: "官网政府客户配置",
  },
  {
    id: "a586d9a8d3e84f9fb8f4d31c63082c87",
    name: "官网区域品牌配置",
  },
  {
    id: "88dc2273078441dfb0c2776e5d02b8e1",
    name: "官网战略合作配置",
  },
  {
    id: "6d599bf40f1b4351aeb8554f2ae96ddb",
    name: "新闻配置",
  },
  {
    id: "d06dc66d5bb043bfa860998e16b48177",
    name: "行业应用数字乡村轮播图",
  },
  {
    id: "22dbfba491f94dc2b941d092ed033f46",
    name: "行业应用数字农业轮播图",
  },
  {
    id: "f97aaccc3b484f6482d1812874721e60",
    name: "行业应用数字乡村",
  },
  {
    id: "bbf205bb55054f3dbb725607d5cc0b8f",
    name: "行业应用数字农业",
  },
  {
    id: "b417fa92b7e645b7ad39ebf241366493",
    name: "官网增值服务轮播图",
  },
  {
    id: "b8c25bba64474c0e942e20d59241db12",
    name: "官网增值服务配置",
  },
  {
    id: "181f37903c884e82979644fb0259a1c4",
    name: "官网超级码云轮播图",
  },
  {
    id: "1542d37f8bb248b3a5075d2ba95fb3a6",
    name: "官网超级码云配置1",
  },
  {
    id: "5a2ea8cc2fd847c4b5f6affa12f57250",
    name: "官网超级码云配置2",
  },
  {
    id: "1d285e74c023466a9732d4698abaac71",
    name: "官网案例展示配置",
  },
  {
    id: "fec9b654987146ccacd19877ff2a568f",
    name: "官网iot轮播图",
  },
  {
    id: "ea313611a52d4d1cb7d4fff6a5c8552c",
    name: "官网iot配置",
  },
  {
    id: "a59660f9af7a4e59820e725d94b3f1e4",
    name: "官网数字农业轮播图",
  },
  {
    id: "fa1ae244b5a6434199411a7c4e825183",
    name: "官网数字农业配置",
  },
  {
    id: "ce868aa839d740249f5ad973590b9d68",
    name: "官网数字乡村轮播图",
  },
  {
    id: "3082736ab4964395b78291ae8510d58f",
    name: "官网数字乡村配置",
  },
  {
    id: "fd79f98777bb487892be55d07f60f69b",
    name: "官网数字乡村配置2",
  },
  {
    id: "b942e69c96624495a6b4ff1741c1313f",
    name: "官网文章管理配置",
  },
  {
    id: "0ef1df73d5334c328c72dfb412d74dc0",
    name: "官网文章管理配置2",
  },
  {
    id: "7497e72883a94755bd064ca2d8c4e6ab",
    name: "帮助中心配置",
  },
  {
    id: "4d86463ceb9f447caf342411c7a6aaad",
    name: "官网关于我们发展历程",
  },
  {
    id: "42e6d6e2e2ef4d9e922d81a2f2efef3a",
    name: "官网关于我们专家团队",
  },
  {
    id: "b0f469311d4943de9ea0cf5855f946dc",
    name: "官网关于我们荣誉资质",
  },
  {
    id: "c7480a26eab94439952b8ad845177b8b",
    name: "官网人事招聘",
  },
  {
    id: "db1f214a07fc42879dbc0f4552945bfd",
    name: "官网关于我们了解",
  },

  {
    id: "56b526d482e54444905042b45320a062",
    name: "官网农业前沿种植",
  },
  {
    id: "cc6d495212454daa82030eecb8786def",
    name: "官网农业前沿养殖",
  },
  {
    id: "25a672bf3c8742f4a9f079eb81b8e673",
    name: "官网农业前沿水产",
  },
  {
    id: "6a7a01a6e39243ac880344d31bda82ec",
    name: "官网农业前沿其它",
  },
  {
    id: "97737b6c75fb4beea00932a5e2eb28c6",
    name: "首页logo移动",
  },
  {
    id: "eaf73370fba543b2b1b4c5b0389a2d2f",
    name: "数据配置移动",
  },
  {
    id: "6bd9d2f604ba4ac8862d5bc2ce4088fd",
    name: "官网轮播图移动",
  },
  {
    id: "c7bb0fed3e6d4f38a106ec22e1ccfb31",
    name: "首页子模块1移动",
  },
  {
    id: "205d1ec055fe47e7bcc68884f818896c",
    name: "首页子模块2移动",
  },
  {
    id: "d59054d8e7a147079a7ea26062b37dc7",
    name: "首页子模块3移动",
  },
  {
    id: "58924820f5864919801cc6e9d20a4dcf",
    name: "首页子模块4移动",
  },
  {
    id: "f70c34c700ff45508f17da61bfa90935",
    name: "首页子模块5移动",
  },
  {
    id: "0a744b1510864c419d02f890a15cf924",
    name: "首页子模块6移动",
  },
  {
    id: "e8cb73ddf6d847aba3e8d0ae402d2878",
    name: "首页子模块7移动",
  },
  {
    id: "78fe8754e8b44404bdda9815479cfe8c",
    name: "友情链接配置移动",
  },
  {
    id: "d3219b07d3fd4948bab63e9560ca1806",
    name: "官网导航移动",
  },
  {
    id: "d7ded35c8eb6477aa9192d6b48fc4cab",
    name: "新媒体矩阵移动",
  },
  {
    id: "7dad35b263b1428ea9feb5d0b5c0724b",
    name: "其它平台号移动",
  },
  {
    id: "af43a420965a4c38a80788251689275d",
    name: "最新动态配置移动",
  },
  {
    id: "c632636064f94f3e89a364ed23660b4a",
    name: "iot轮播图移动",
  },
  {
    id: "09c28efd217f4e66a88f6af36c659a20",
    name: "iot配置官网",
  },
  {
    id: "d2e4e13550b941e190630b0db51cc784",
    name: "增值服务轮播移动",
  },
  {
    id: "0ab22e7fc4f24dc898437339e809197c",
    name: "增值服务配置移动",
  },
  {
    id: "35c09b81db444fa0a0da8c8e2e017afb",
    name: "官网文章管理配置移动",
  },
  {
    id: "ae2fd12db94e4246a0789b30a59f5f88",
    name: "数字农业轮播移动",
  },
  {
    id: "eea4d4d90b204ebfad389548a5869f46",
    name: "数字农业配置移动",
  },
  {
    id: "781d9da664a841799a81176b30077e3a",
    name: "数字乡村轮播移动",
  },
  {
    id: "1bd10a30bf9a4f6e836f52e673c3e3d7",
    name: "数字乡村配置移动",
  },
  {
    id: "a03c3bb60b03438b859e18e2f4d6c48f",
    name: "行业应用农业轮播移动",
  },
  {
    id: "6ed356accd574a18b12722132c476d1f",
    name: "行业应用乡村轮播移动",
  },
  {
    id: "aef80c52b9cc43b1b19b8212d18f9b03",
    name: "行业应用数字乡村移动",
  },
  {
    id: "14da53ed16594c41b919d3598cebf8a4",
    name: "行业应用数字农业移动",
  },

  {
    id: "b74689eb1f854d69ba2f128b2d0f1ad4",
    name: "帮助中心配置移动",
  },
  {
    id: "c3d12c91ff6f41d3aac507880c3607db",
    name: "新闻管理移动",
  },
  {
    id: "5b8df288e5864b77a0e7ee03ddad87d4",
    name: "人事招聘移动",
  },
  {
    id: "ae23a5234d834960834215e9b9a1adb0",
    name: "发展历程移动",
  },
  {
    id: "b67a587d740544c3a1487a9c4228f6e0",
    name: "关于专家团队移动",
  },
  {
    id: "381235b44c824f0a976f17cec8c9b55f",
    name: "荣誉资质移动",
  },
  {
    id: "84d0630ced8a4c0db1bbb7b26f4977eb",
    name: "了解移动",
  },

  {
    id: "ff775cf2b6a04d9d9a53f7b8c6c46429",
    name: "企业客户配置移动",
  },
  {
    id: "10526b0c5f594af58a0601ea55746f60",
    name: "政府客户配置移动",
  },
  {
    id: "9a11936857e34ab9a1e182b1c17f9c31",
    name: "区域品牌配置移动",
  },
  {
    id: "2e1103786fc34d18bd8486f09b006551",
    name: "战略合作配置移动",
  },
];
